import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Grid, Segment, Form } from 'semantic-ui-react';
import { Formik } from 'formik';

import { getUserProfile, updateUser } from '../../store/actions';
import { CustomInput } from '../../components/form';

import {
  getProfileDetailsInitialValues,
  profileDetailsValidationSchema,
} from '../../validations/profileDetailsValidation';

class ProfileDetails extends PureComponent {
  componentDidMount() {
    this.props.getUserProfile();
  }

  async onSubmit(values) {
    let newValues = { ...values };
    const { getUserProfile, updateUser } = this.props;

    ['email', 'department'].forEach((fld) => {
      if (newValues.hasOwnProperty(fld)) {
        delete newValues[fld];
      }
    });

    await updateUser(newValues);
    getUserProfile();
  }

  render() {
    const {
      auth: { updatingUser, user },
      t,
    } = this.props;

    const loading = updatingUser;

    return (
      <Segment loading={loading}>
        <Formik
          initialValues={getProfileDetailsInitialValues(user)}
          onSubmit={(values) => {
            this.onSubmit(values);
          }}
          validationSchema={profileDetailsValidationSchema(t)}
        >
          {({ handleSubmit, isSubmitting, values }) => (
            <Form onSubmit={handleSubmit}>
              <Grid columns={2} stackable>
                <Grid.Row className="profile-row">
                  <Grid.Column
                    mobile={16}
                    tablet={8}
                    computer={6}
                    className="profile-sub-column-new"
                  >
                    <CustomInput
                      id="firstName"
                      name="firstName"
                      labelText={t('formulary.first_name')}
                      requiredStar
                    />

                    <CustomInput
                      id="email"
                      name="email"
                      labelText={t('formulary.email')}
                      disabled
                      requiredStar
                    />

                    {values.department && (
                      <CustomInput
                        id="department"
                        name="department"
                        labelText={user.department.hierarchy.deptLabel || '-'}
                        disabled
                      />
                    )}

                    <CustomInput
                      id="positionTitle"
                      name="positionTitle"
                      labelText={t('formulary.position_designation')}
                    />

                    {isMobile ? null : (
                      <Button
                        disabled={loading}
                        loading={loading}
                        type="submit"
                        className="Primary-Button"
                      >
                        {t('actions.save')}
                      </Button>
                    )}
                  </Grid.Column>
                  <Grid.Column
                    mobile={16}
                    tablet={8}
                    computer={6}
                    className="profile-sub-column-new sub-columnRight"
                  >
                    <CustomInput
                      id="surname"
                      name="surname"
                      labelText={t('formulary.surname')}
                      requiredStar
                    />

                    <CustomInput
                      id="phone"
                      name="phone"
                      labelText={t('formulary.contact_number')}
                      requiredStar
                    />

                    {!isMobile ? null : (
                      <Button
                        disabled={loading}
                        loading={loading}
                        type="submit"
                        className="Primary-Button"
                      >
                        {t('actions.save')}
                      </Button>
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          )}
        </Formik>
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getUserProfile,
      updateUser,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ProfileDetails));
